import cn from 'classnames';
import TrancheField from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/TrancheField';
import { LeftLeadBillingDelivering } from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/Tranche/cells/LeftLeadBillingDelivering';
import type ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';
import { useDealPageContext } from '@/creditflowresearch/application/Deal/contexts/DealPageContext';
import { useDictionariesContext } from '@/creditflowresearch/application/Dictionaries/v2/DictionariesContext';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/Tranche/tranche.module.scss';

const Tranche = ({ tranche }: { tranche: ITranch }) => {
  const { deal } = useDealPageContext();
  const { sizeDescriptions } = useDictionariesContext();
  const sizeDescription = sizeDescriptions.getById(tranche.sizeDescriptionId);

  return (
    <div
      className={ cn(styles.tranche, {
      [styles.dropped]: tranche.droppedTranche,
    }) }
    >
      <div className={ styles.trancheContainer }>
        <div className={ styles.gridContainer }>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="currency" value={ tranche.size } />
            <TrancheField fieldKey="size" value={ { ...tranche, status: deal.status } } />
            <TrancheField fieldKey="maturity" value={ tranche.maturityDate } />
            <TrancheField fieldKey="type" value={ tranche.couponType?.name } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField
              fieldKey="tenor"
              value={ (!tranche.tenorYrs && tranche.perpetual) ? 'Perp' : tranche.tenorYrs }
            />
            <TrancheField fieldKey="call" value={ tranche.call } />
            <TrancheField fieldKey="registration" value={ tranche.registration } />
            <TrancheField fieldKey="benchmark" value={ tranche.benchmark } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="ranking" value={ tranche.ranking?.name } />
            <TrancheField fieldKey="moodys" value={ tranche.ratings } />
            <TrancheField fieldKey="sp" value={ tranche.ratings } />
            <TrancheField fieldKey="fitch" value={ tranche.ratings } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="sizeDescription" value={ sizeDescription } />
            <TrancheField fieldKey="reOpen" value={ tranche.reOpen } />
          </div>
        </div>

        <div className={ styles.gridContainer }>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="ipt" value={ tranche.guidanceIpt } />
            <TrancheField fieldKey="iptPxd" value={ tranche.iptPxd } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="guidance" value={ tranche.guidance } />
            <TrancheField fieldKey="spread" value={ tranche.spread } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="coupon" value={ tranche.coupon } />
            <TrancheField fieldKey="spreadSet" value={ tranche.spreadSet } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="price" value={ tranche.issuePrice } />
            <TrancheField fieldKey="yield" value={ tranche.yield } />
          </div>
        </div>

        <div className={ cn(styles.gridContainer, styles.desktopOnly) }>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="bookSize" value={ tranche.bookSize } />
            <TrancheField fieldKey="peakBook" value={ tranche.peakBook } />
            <TrancheField fieldKey="bookXCovered" value={ tranche.bookXCovered } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="bookAttrition" value={ tranche.bookAttrition } />
            <TrancheField fieldKey="newIssueConcession" value={ tranche.newIssueConcession } />
          </div>
          <div className={ styles.gridItem }>
            <LeftLeadBillingDelivering tranche={ tranche } />
            <TrancheField fieldKey="activeLeads" value={ tranche } />
            <TrancheField fieldKey="jointLeads" value={ tranche } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="passiveLeads" value={ tranche } />
            <TrancheField fieldKey="coManagers" value={ tranche } />
            <TrancheField fieldKey="coordinatingManagers" value={ tranche } />
          </div>
        </div>

        <div className={ cn(styles.gridContainer, styles.mobileOnly) }>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="bookSize" value={ tranche.bookSize } />
            <TrancheField fieldKey="peakBook" value={ tranche.peakBook } />
            <TrancheField fieldKey="bookXCovered" value={ tranche.bookXCovered } />
            <TrancheField fieldKey="bookAttrition" value={ tranche.bookAttrition } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="newIssueConcession" value={ tranche.newIssueConcession } />
            <LeftLeadBillingDelivering tranche={ tranche } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="activeLeads" value={ tranche } />
            <TrancheField fieldKey="jointLeads" value={ tranche } />
          </div>
          <div className={ styles.gridItem }>
            <TrancheField fieldKey="passiveLeads" value={ tranche } />
            <TrancheField fieldKey="coManagers" value={ tranche } />
            <TrancheField fieldKey="coordinatingManagers" value={ tranche } />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tranche;
